import React, {useState, useEffect} from "react";
import {
    FormControl,
    MenuItem,
    Select,
    Typography,
    Grid,
    Paper,
    TableContainer,
    TableCell,
    Table,
    TableRow,
    TableHead,
    TableBody
} from '@material-ui/core';

const DISPLAY_OPTIONS = ["HIDE", "SHOW"];
const ARISING_OUT_OF = ["IN", "WITH"]; 

const ReferenceCase = ({classes, formData, handleInputChange, searchResponse, setFormData, isActionsRequired = true}) => {
    const [errors, setErrors] = useState({
        petitionerAdvocate: '',
        respondentAdvocate: '',
    });
    const [localReferenceCases, setLocalReferenceCases] = useState([]);
    const [connectedCases, setConnectedCase] = useState([]);

    useEffect(() => {
        if (searchResponse?.reference_cases) {
            // Map searchResponse's reference cases to the local state, setting default display_in_causelist and arisingOutOf values
            const initializedReferenceCases = searchResponse.reference_cases.map(refCase => ({
                reference_case: refCase.id,
                primary_case: refCase?.main_case?.id, 
                arisingOutOf: "WITH", // default value or you can map it from refCase if available
                display_in_causelist: true // default value or map it from refCase if available
            }));
            setFormData(prev => ({
              ...prev,
              reference_cases: initializedReferenceCases
            }));
            setLocalReferenceCases(initializedReferenceCases);
        }
        if(searchResponse?.connected_cases){
          setConnectedCase(searchResponse?.connected_cases);
        }
    }, [searchResponse]);

    // Function to handle change in reference case data
      const handleReferenceCaseChange = (index, field, value) => {
        const updatedReferenceCases = [...localReferenceCases];
        // Handle the "display_in_causelist" logic
        if (field === "display_in_causelist") {
            updatedReferenceCases[index][field] = value === "SHOW"; // true if SHOW, false if HIDE
        } else {
            updatedReferenceCases[index][field] = value;
        }

        setLocalReferenceCases(updatedReferenceCases);

        // Update formData with the modified reference cases
        setFormData(prev => ({
          ...prev,
          reference_cases: updatedReferenceCases
        }));
    };
    
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid
            item
            container
            style={{
              width: "100%",
              textAlign: "left",
              marginBottom: "1rem",
              padding: "1rem",
              border: "1px solid #e9e9e9",
            }}
          >
            <Grid item xs={12}>
              <Typography variant="h6" style={{fontFamily:'Satoshi-Bold', textAlign:'center'}}>Connected Cases</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography style={{fontFamily:'Satoshi-Bold'}}>
                Case Number:{" "}
              </Typography>
              {connectedCases
                ?.map((item, index) => {
                  return (
                    <Typography
                      key={index}
                      style={{ textTransform: "uppercase" }}
                    >
                      {item?.case_number} {""}
                    </Typography>
                  );
                })}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <TableContainer component={Paper} style={{border: '1px solid #E5E5E5'}}>
                <Typography variant="h6" style={{fontFamily:'Satoshi-Bold', textAlign:'center', padding:'8px'}}>Reference Cases</Typography>
                <Table className={classes.table} style={{minWidth:'auto', margin: 'auto'}}>
                  <TableHead>
                    <TableRow style={{borderBottom: '1px solid #E5E5E5', borderTop: '1px solid #E5E5E5'}}>
                      {isActionsRequired && (
                        <TableCell className={classes.noBordersTitle} style={{width:'28%'}}>
                          Display In CauseList
                        </TableCell>
                      )}
                      <TableCell className={classes.noBordersTitle}>
                        Main Case No.
                      </TableCell>
                      <TableCell className={classes.noBordersTitle}>
                        Reference Case
                      </TableCell>
                      {isActionsRequired && (
                        <TableCell className={classes.noBordersTitle} style={{width:'20%'}}>
                          Display
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {localReferenceCases?.length > 0 ? (
                      localReferenceCases.map((row, index) => (
                        <TableRow key={index}>
                          {isActionsRequired && (
                            <TableCell className={classes.noBorders}>
                              <FormControl
                                fullWidth
                                margin="none"
                                variant="outlined"
                                size="small"
                              >
                                <Select
                                  name="arisingOutOf"
                                  value={row.arisingOutOf}
                                  onChange={(e) =>
                                    handleReferenceCaseChange(
                                      index,
                                      "arisingOutOf",
                                      e.target.value
                                    )
                                  }
                                >
                                  {ARISING_OUT_OF.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                          )}
                          <TableCell className={classes.noBorders}>
                            {searchResponse?.reference_cases?.[index]?.main_case?.case_number}
                          </TableCell>
                          <TableCell className={classes.noBorders}>
                            {searchResponse?.reference_cases?.[index]?.case_number}
                          </TableCell>
                          {isActionsRequired && (
                            <TableCell className={classes.noBorders}>
                              <FormControl
                                fullWidth
                                margin="none"
                                variant="outlined"
                                size="small"
                              >
                                <Select
                                  name="display"
                                  value={
                                    row.display_in_causelist ? "SHOW" : "HIDE"
                                  }
                                  onChange={(e) =>
                                    handleReferenceCaseChange(
                                      index,
                                      "display_in_causelist",
                                      e.target.value
                                    )
                                  }
                                >
                                  {DISPLAY_OPTIONS.map((option, index) => (
                                    <MenuItem key={index} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          className={classes.noBorders}
                          align="center"
                        >
                          No Reference Case
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
}

export default ReferenceCase;